import { render } from "./PeppolDocuments.vue?vue&type=template&id=389ed30a&scoped=true"
import script from "./PeppolDocuments.vue?vue&type=script&lang=js"
export * from "./PeppolDocuments.vue?vue&type=script&lang=js"

import "./PeppolDocuments.vue?vue&type=style&index=0&id=389ed30a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-389ed30a"]])

export default __exports__